import { cn } from "@tine/designsystem-utils";
import { observer } from "mobx-react-lite";

type NotificationBadgeProps = {
   count: number;
};
const notificationBadgeStyle = cn(
   "bg-notification-bg text-notification-text",
   "size-5 rounded-full text-center align-middle text-xs leading-5"
);

const NotificationsBadge = ({ count }: NotificationBadgeProps) => {
   if (count > 0) {
      return (
         <div className={notificationBadgeStyle} role="img" aria-label={`${count} uleste varslinger`}>
            {count}
         </div>
      );
   }
};

export default observer(NotificationsBadge);
